<div mat-dialog-title class="d-flex justify-content-between align-items-center mt-3">
    <div></div>
    <mat-icon class="w-25 mx-auto" style="height: 50px;" [svgIcon]="missedCallIcon"></mat-icon>
    <button color="warn" *ngIf="data.missedCallSettings" (click)="onDelete(data.missedCallSettings.id!)" mat-mini-fab>
        <mat-icon>delete</mat-icon>
    </button>
</div>


<mat-divider></mat-divider>

<mat-dialog-content>
    <div class="container-fluid-p-2" [formGroup]="missedCallSettingsForm">
        <app-minutes-time-unit-mapping class="row" (minutesValueChanged)="onMinutesValueChange($event)"
            [minutesValue]="scheduledAt"
            [labelValue]="appMinuteTimeUnitMappingLabel"></app-minutes-time-unit-mapping>
        <div class="row">
            <mat-form-field class="w-100 no-margin" appearance="outline">
                <mat-label>The maximum amount of time you would like to call the customer back</mat-label>
                <input matInput type="number" placeholder="Set your custom after-call text message"
                    formControlName="callbackMaxAttempts">
            </mat-form-field>
        </div>
    </div>
</mat-dialog-content>
<p class="text-danger" *ngIf="errorMessage">{{errorMessage}}</p>
<mat-divider></mat-divider>


<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" [disabled]="isLoading" color="warn">Close</button>
    <button mat-raised-button class="w-25" [disabled]="isLoading|| !missedCallSettingsForm.valid" (click)="onSubmit()"
        color="primary">
        <span *ngIf="!isLoading">
            Save
        </span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>